import React, { useMemo } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { PrimaryButton } from 'office-ui-fabric-react';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { Text } from 'office-ui-fabric-react/lib/Text';
import TextButton from '../../components/TextButton';
import Module from '../../components/Module';
import ModuleHeader from '../../components/ModuleHeader';
import ModuleContent from '../../components/ModuleContent';
import Main from '../../components/Main';
import PageTitle from '../../components/PageTitle';
import SubModule from '../../components/SubModule';
import SubModuleContent from '../../components/SubModuleContent';
import SubModuleHeader from '../../components/SubModuleHeader';
import useAPI from '../../hooks/useAPI';
import styles from './AddScopeFilters.style';
import ScopeFiltersForm from '../../components/ScopeFiltersForm';
import FilterDetails from '../../components/FilterDetails';
import { fetchContract } from '../../actions/contracts';

const AddScopeFilters = () => {
  const history = useHistory();
  const { contractAddress } = useParams();
  const contract = useSelector(state => get(state, `entities.contracts.${contractAddress}`, null));
  const { isLoading, error } = useAPI(() => fetchContract(contractAddress, { useCache: false }));
  const errorDetail = useMemo(() => {
    if (!error) {
      return null;
    }
    let title = 'Whoops!';
    let message = 'Something went wrong. Please refresh the page to try again.';
    if (error.status === 404) {
      message = 'This contract does not exist. Please try a different link.';
      title = 'Not Found';
    }
    return {
      title,
      message,
    };
  }, [error]);

  if (isLoading) {
    return (
      <Spinner
        data-testid="addScopeFiltersSpinner"
        size={SpinnerSize.medium}
        className={styles.loadingSpinner}
      />
    );
  }

  if (errorDetail) {
    return (
      <>
        <PageTitle>{errorDetail.title}</PageTitle>
        <Main>
          <Text>{errorDetail.message}</Text>
        </Main>
      </>
    );
  }

  const handleCancel = () => {
    // Re-direct to contract details page
    history.push(`/contracts/${contractAddress}`);
  };
  const handleContinue = () => {
    history.push(`/contracts/${contractAddress}/add-calc-features`);
  };

  return (
    contract && (
      <>
        <PageTitle>Add Contract</PageTitle>

        <Main>
          <Module>
            <ModuleHeader variant="xLarge">
              <span className={styles.moduleHeaderText}>Scope Filters</span>
            </ModuleHeader>

            <ModuleContent>
              <SubModule disableAccordian>
                <SubModuleHeader noBorder noSpacing>
                  Active Scope Filters
                </SubModuleHeader>
                <SubModuleContent>
                  <FilterDetails filters={contract.scopeFilter?.filters} />
                  <ScopeFiltersForm contract={contract} />
                </SubModuleContent>
              </SubModule>
            </ModuleContent>
          </Module>

          <div className={styles.buttonContainer}>
            <TextButton className={styles.cancelButton} onClick={handleCancel}>
              Cancel
            </TextButton>
            <PrimaryButton type="submit" onClick={handleContinue}>
              Continue
            </PrimaryButton>
          </div>
        </Main>
      </>
    )
  );
};

export default AddScopeFilters;
